import { Action } from "redux";

export const SET_CHANGE_TYPES = "SET_CHANGE_TYPES";

export interface SetChangeTypesAction extends Action {
    changeTypes: string[];
}

export const setChangeTypesAction = (changeTypes: string[]): SetChangeTypesAction => {
    return {
        type: SET_CHANGE_TYPES,
        changeTypes: changeTypes,
    };
};
